<template>
    <div class="purchase-course vod exam">

        <div class="row justify-content-center">
            <div class="col-md-12">

                <!-- FREE -->
                <template v-if="isFree">
                    <div class="block left">
                        <div class="row">
                            <div class="col-12 col-lg-8">
                                <h3>
                                    {{ exam.name }}
                                </h3>

                                <ul>
                                    <template v-if="exam.isUserEnrolled">
                                        <li>You're already on this assessment, let's get started.</li>
                                    </template>
                                    <template v-else>
                                        <li>This is a free assessment, you just need an account to take it.</li>
                                    </template>

                                    <template v-if="exam.prospectusMarkdownMD && exam.prospectusMarkdownMD.length > 0">
                                        <li><a href="javascript:void(0)" @click="openProspectusModal">Assessment overview</a></li>
                                    </template>

                                    <template v-if="exam.prospectusAbsolutePath && exam.prospectusAbsolutePath.length > 0">
                                        <li><a :href="exam.prospectusAbsolutePath" target="_blank" download>Download the guide</a></li>
                                    </template>

                                    <li v-if="exam.type === 'assessed'">Please note: After enrolling in this assessment, please allow us up with 24 hours to allocate an examiner, and to prepare your assessment materials</li>

                                    <li v-for="bullet in exam.bullets" :key="bullet.id">{{ bullet.name }}</li>
                                </ul>
                            </div>
                            <div class="col-12 col-lg-4 meta-col d-flex align-items-stretch">
                                <div class="meta-info">
                                    <template v-if="!exam.isUserEnrolled">
                                        <template v-if="!isAuth">

                                            <template v-if="isSpotifyReferral">
                                                <a :href="'/register/spotify?return=' + exam.uri" class="btn btn-sso btn-block btn-slimpad btn-spotify">
                                                <span>
                                                    <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'spotify' }" />
                                                </span>
                                                    <span class="text">Login with Spotify</span>
                                                </a>
                                            </template>
                                            <template v-else>
                                                <a :href="'/register?return=' + exam.uri" class="btn btn-primary btn-slimpad btn-block btn-white">Enrol</a>
                                            </template>

                                        </template>
                                        <template v-else>

                                            <template v-if="exam.isUserEnrolled">
                                                <a :href="exam.examroomUri" class="btn btn-primary btn-block mt-3">Go to Assessment</a>
                                            </template>
                                            <template v-else>
                                                <enrol-exam-button-component
                                                    :exam="exam"
                                                    :user="user"
                                                    :purchase-intent="'free'">Take Exam</enrol-exam-button-component>
                                            </template>

                                        </template>

                                        <p class="included">This is a free assessment, you just need an account to take it.</p>
                                    </template>
                                    <template v-else>
                                        <a :href="exam.examroomUri" class="btn btn-primary btn-block mt-3">Go to Assessment</a>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                </template>
                <!-- EO FREE -->
                <!-- PAID -->
                <template v-else>
                    <!-- Show the One-off box -->
                    <div class="block left">
                        <div class="row">
                            <div class="col-12 col-lg-8">
                                <h3>
                                    {{ exam.name }}
                                </h3>

                                <ul>
                                    <li v-if="exam.prospectusMarkdownMD && exam.prospectusMarkdownMD.length > 0"><a href="javascript:void(0)" @click="openProspectusModal">Assessment overview</a></li>
                                    <li v-if="exam.type === 'assessed'">Please note: After purchasing your assessment, please allow us up with 24 hours to allocate an examiner, and to prepare your exam materials.</li>
                                    <li v-if="exam.prospectusAbsolutePath && exam.prospectusAbsolutePath.length > 0"><a :href="exam.prospectusAbsolutePath" target="_blank" download>Download the guide</a></li>
                                    <li v-for="bullet in exam.bullets" :key="bullet.id">{{ bullet.name }}</li>
                                </ul>
                            </div>
                            <div class="col-12 col-lg-4 meta-col d-flex align-items-stretch">
                                <div class="meta-info">
                                    <template v-if="isAuth">
                                        <template v-if="exam.isUserEnrolled">
                                            <a :href="exam.examroomUri" class="btn btn-primary btn-block">Go to Assessment</a>
                                        </template>
                                        <template v-else>
                                            <button @click="buyClick" class="btn btn-primary btn-slimpad btn-block btn-white">Enrol</button>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-if="isSpotifyReferral">
                                            <a :href="'/register/spotify?return=' + exam.uri" class="btn btn-sso btn-block btn-slimpad btn-spotify">
                                                <span>
                                                    <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'spotify' }" />
                                                </span>
                                                <span class="text">Login with Spotify</span>
                                            </a>
                                        </template>
                                        <template v-else>
                                            <a :href="'/register?return=' + exam.uri" class="btn btn-primary btn-slimpad btn-block btn-white">Enrol</a>
                                        </template>
                                    </template>

                                    <p class="price">
                                        <template v-if="isSubscribed && userTier == 'premium'">
                                            <span class="text-strikethrough">{{ exam.priceLabelRRP }}</span><br>
                                            Your price: {{ exam.priceLabelSubscription }}
                                        </template>
                                        <template v-else>
                                            RRP: {{ exam.priceLabelRRP }}<br>
                                            Premium Member: {{ exam.priceLabelSubscription }}
                                        </template>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <!-- EO PAID -->

                <b-modal ref="prospectusModal" size="lg" centered :title="exam.name + ' assessment overview'" :ok-only="true" ok-variant="link" ok-title="Close">
                    <h2>Assessment overview</h2>
                    <div v-html="exam.prospectusMarkdownMD"></div>
                </b-modal>

                <template v-if="!exam.isUserEnrolled && !isFree">
                    <b-modal ref="buyModal" size="lg" centered :title="'Purchase ' + exam.name" :ok-only="true" ok-variant="link" ok-title="Close">
                        <template v-if="showPrefaceOnModal">
                            <h2>Description</h2>
                            <div v-html="exam.descriptionMD" class="mb-4"></div>

                            <div v-if="exam.requirements" class="mb-4">
                                <h2>Requirements</h2>
                                <div v-html="exam.requirementsMD"></div>
                            </div>

                            <button type="button" class="btn btn-primary" @click="showPrefaceOnModal = false">Continue</button>
                        </template>
                        <template v-else>
                            <buy-exam-button-component
                                :exam="exam"
                                :user="user"
                                :is-new-user="isNewlyRegistered"></buy-exam-button-component>
                        </template>
                    </b-modal>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            vodCourse: {
                type: Object,
                required: true,
            },
            exam: {
                type: Object,
                required: true,
            },
            isSpotifyReferral: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        data() {
            return {
                isAuth: false,
                user: {},
                id: null,
                isBusy: false,
                isFree: false,
                isSubscribed: false,
                isNewlyRegistered: false,
                isFreemiumUser: false,
                isSchoolUser: false,
                credits: 0,
                showPrefaceOnModal: true,
                userTier: null,
            }
        },

        mounted() {
            // User logged in?
            if(window.virtuoso) {
                if(window.virtuoso.is_auth) {
                    this.isAuth = true;
                    this.user = window.virtuoso.user;
                    this.isFreemiumUser = this.user.isFreemium;
                    this.isSchoolUser = this.user.isSchoolUser;
                }
                this.isSubscribed = window.virtuoso.is_subscribed;
                this.userTier = window.virtuoso.tier;

                if(this.isSubscribed) {
                    this.credits = window.virtuoso.credits;
                }
            }

            this.isFree = this.exam.is_free; // We check server side so it's safe to do whatever here

            this.isNewlyRegistered = new URL(location.href).searchParams.get('registered') ? true : false;
        },

        methods: {
            // Clicked to apply for a seat
            buyClick() {
                this.showPrefaceOnModal = true;
                this.$refs['buyModal'].show('buyModal');
            },

            openProspectusModal() {
                this.$refs['prospectusModal'].show('prospectusModal');
            },
        }
    }
</script>
